module.exports = __webpack_public_path__ + "static/media/UmaSwamy@2x.b313b021.png";